import { useMutation } from 'react-query';

import { apiUrl } from 'src/core/utils/api';

export const useReplaceCostCenterMutation = () => {
  return useMutation({
    mutationFn: async (payload: {
      costCenterId: string;
      companyId: string;
      replacementId: string;
    }) => {
      await fetch(
        apiUrl(
          `/cost-centers/${payload.costCenterId}/replace`,
          payload.companyId,
        ),
        {
          method: 'POST',
          body: JSON.stringify({
            replacementId: payload.replacementId,
          }),
          credentials: 'include',
          headers: {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            'Content-Type': 'application/json',
          },
        },
      );
    },
  });
};
